<script setup lang="ts">
import { computed } from 'vue';
import VSelect from '../VSelect/VSelect.vue';
import KvkBedrijfOption from './KvkBedrijfOption.vue';
import { useKvkBedrijfSearch } from './useKvkBedrijfSearch';

const props = withDefaults(
  defineProps<{
    id?: string;
    disabled?: boolean;
    readonly?: boolean;
    placeholder?: string;
    clearToUndefined?: boolean;
  }>(),
  {
    disabled: false,
    readonly: false,
    placeholder: 'Zoek op bedrijfsnaam of KVK-nummer',
    clearToUndefined: false,
  },
);

defineOptions({
  inheritAttrs: false,
});

const kvkNummerModel = defineModel<string | undefined>('kvkNummer');
const {
  modelValue,
  options,
  props: selectProps,
} = useKvkBedrijfSearch(kvkNummerModel, {
  emptyKvkNummerValue: props.clearToUndefined ? undefined : '',
});

const vSelectProps = computed(() => ({
  ...selectProps,
  id: props.id,
  disabled: props.disabled,
  readonly: props.readonly,
  placeholder: props.placeholder,
}));
</script>

<template>
  <VSelect
    v-bind="{ ...$attrs, ...vSelectProps }"
    class="w-full"
    v-model="modelValue"
    :options="options"
    v-slot="{ option }"
  >
    <KvkBedrijfOption :option="option" />
  </VSelect>
</template>
